module.exports = __webpack_public_path__ + "static/media/nissan-phone.ff54c07c.svg";